import React from 'react'
import AdvertHero from '../../components/Averts/AdvertHero'
import WhyAdvert from '../../components/Averts/WhyAdvert'
import AdvertRequestForm from '../../components/Averts/SubmitAdvert'
import Footer from '../../components/shared/Footer'
import Header from '../../components/shared/Header'
import BasicCollaborators from '../../components/shared/BasicCollaborators'

function Advert() {
  return (
    <div>
      <Header/>
      <AdvertHero/>
      <WhyAdvert/>
      <AdvertRequestForm/>
      <BasicCollaborators/>
      <Footer/>
      
    </div>
  )
}

export default Advert